module.exports = __webpack_public_path__ + "img/qrcode.0b9e380e.jpg";